import PolicyholderInfo from './PolicyholderInfo';
export default PolicyholderInfo;
